import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { trackCta } from '../../utils/tracking';
type Variant = 'primary' | 'secondary' | 'ghost' | 'onDark';
type Props = {
  children: React.ReactNode;
  to?: string;
  href?: string;
  variant?: Variant;
  size?: 'md' | 'lg';
  withArrow?: boolean;
  trackingLocation?: string;
  className?: string;
  onClick?: () => void;
  type?: 'button' | 'submit';
};
const base = 'inline-flex items-center justify-center gap-2 font-semibold rounded-sm transition-colors transition-transform duration-150 ease-smooth active:translate-y-px disabled:opacity-60';
const variants: Record<Variant, string> = {
  primary: 'bg-brand-700 text-white hover:bg-brand-600',
  secondary: 'bg-white text-brand-800 border border-mist-300 hover:border-brand-400 hover:text-brand-700',
  ghost: 'text-brand-700 hover:text-brand-600',
  onDark: 'bg-white/10 text-white border border-white/25 backdrop-blur-sm hover:bg-white/20'
};
const sizes = {
  md: 'text-sm px-5 py-3',
  lg: 'text-[15px] px-7 py-4'
};
export function Button({
  children,
  to,
  href,
  variant = 'primary',
  size = 'md',
  withArrow = false,
  trackingLocation = 'general',
  className = '',
  onClick,
  type = 'button'
}: Props) {
  const classes = `${base} ${variants[variant]} ${sizes[size]} ${className}`;
  const label = typeof children === 'string' ? children : 'cta';
  const handleClick = () => {
    trackCta(label, trackingLocation);
    onClick?.();
  };
  const inner = <>
      <span data-id="element-441" data-mp="xnqsmnzie6by">{children}</span>
      {withArrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-442" data-mp="xmo1cey9y1vi" />}
    </>;
  if (to) {
    return <Link to={to} className={classes} onClick={handleClick} data-id="element-443" data-mp="1cf988koghyus">
        {inner}
      </Link>;
  }
  if (href) {
    return <a href={href} className={classes} onClick={handleClick} target={href.startsWith('http') ? '_blank' : undefined} rel={href.startsWith('http') ? 'noreferrer' : undefined} data-id="element-444" data-mp="1ldl1kugpjaqx">
        {inner}
      </a>;
  }
  return <button type={type} className={classes} onClick={handleClick} data-id="element-445" data-mp="1oh0ox3bb4ooy">
      {inner}
    </button>;
}